var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAllow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.956 5.49992H6.731V2.49992C6.7627 2.29569 6.74578 2.08686 6.68161 1.8904C6.61744 1.69394 6.50783 1.51538 6.36169 1.36924C6.21554 1.22309 6.03699 1.11348 5.84053 1.04931C5.64406 0.985145 5.43523 0.968223 5.231 0.999925C5.12609 1.00717 5.02612 1.0473 4.94534 1.11463C4.86455 1.18195 4.80704 1.27304 4.781 1.37492L3 6.99992V12.9999H9.431C9.9079 12.9907 10.366 12.8121 10.7232 12.496C11.0805 12.18 11.3137 11.7471 11.381 11.2749L11.981 7.82492C12.0282 7.54546 12.0123 7.25896 11.9344 6.98644C11.8566 6.71392 11.7187 6.46227 11.531 6.24992C11.3484 6.00721 11.1098 5.81224 10.8355 5.68165C10.5613 5.55106 10.2595 5.48871 9.956 5.49992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.99994H0V12.9999H2V6.99994Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAllow);
export default __webpack_public_path__ + "static/media/icon_allow.163b848c.svg";
export { ForwardRef as ReactComponent };